import { render, staticRenderFns } from "./insertCourse.vue?vue&type=template&id=73f1f09e&scoped=true&"
import script from "./insertCourse.vue?vue&type=script&lang=js&"
export * from "./insertCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1f09e",
  null
  
)

export default component.exports